import others from './../images/others.png';

const Other = () => {
    return (
      <div>
      <p className="standard-paragraph">

      <div class="container">
        <div class="image-container">
          <img src={others} alt="Others" width={300}/>
        </div>
        <div class="text-container">
          <h2>Other</h2>
          <p class="text-text">  
            Discover the limitless possibilities with our AWS services, where we specialize in tailoring solutions to match your unique needs. 
            If you're seeking non-standard AWS services that go beyond our listed offerings, we invite you to reach out. Our expert team is 
            ready to collaborate on custom AWS solutions and provide comprehensive software development services, ensuring your vision is 
            transformed into reality with precision and innovation. Contact us to explore the uncharted territories of AWS tailored to your 
            specific requirements.
          </p>
        </div>
      </div>
      </p>
      </div>
      )
  };
  
  export default Other;